import { isStringOrNullInventoryListingConfig } from "@dealer-center/ddc-pages-inventory-config-interface";
import type { getDifferencesBetweenConfigsReturn } from ".";

export function RenderStringChange(change: getDifferencesBetweenConfigsReturn) {
  const { oldValue, newValue, config } = change;
  if (
    isStringOrNullInventoryListingConfig(newValue) &&
    isStringOrNullInventoryListingConfig(oldValue)
  ) {
    if (newValue === oldValue) {
      return null;
    }
    if (!newValue && !oldValue) {
      return null;
    }
    return (
      <li>
        <b>{config}</b> changed from <b>"{oldValue?.toString()}"</b> to{" "}
        <b>"{newValue}"</b>
      </li>
    );
  }
  return null;
}
